// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6498":"79879b82","8536":"79879b82"}[chunkId] + ".chunk.css";
};